import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Loader from 'src/components/loader/loader';
import { Box, Grid, IconButton, Tab, Tabs, TextField, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { useCallback, useEffect, useRef, useState } from 'react';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
// Import 2 file con vừa tách
import TabUserReturn from './TabUserReturn';
import TabAdminAssign from './TabAdminAssign';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function ApproveChangeDevice({
    loading,
    visible = false,
    setVisible,
    data,
    idPermission = 1,
    callBackFunct = () => null,
}) {
    const { t } = useTranslation();
    const [flagProcess, setFlagProcess] = useState(false);

    // -- Common Fields --
    const [noteChange, setNoteChange] = useState('');
    const [quantityChange, setQuantityChange] = useState('');

    const flagRef = useRef(false);
    const isHandledRef = useRef(false);
    const [tabValue, setTabValue] = useState(0);

    // ================== LOGIC TAB 1: USER (Giữ nguyên logic cũ) ==================
    const [dataDrawer, setDataDrawer] = useState([]);
    const [dataCabinet, setDataCabinet] = useState([]); // Dùng chung list Cabinet
    const [dataCell, setDataCell] = useState([]);
    const [selectDrawer, setSelectDrawer] = useState(0);
    const [selectCabinet, setSelectCabinet] = useState(0);
    const [selectedCell, setSelectedCell] = useState(null);

    // ================== LOGIC TAB 2: ADMIN (Tạo riêng state) ==================
    const [dataDrawerAdmin, setDataDrawerAdmin] = useState([]);
    const [dataCellAdmin, setDataCellAdmin] = useState([]);
    const [selectDrawerAdmin, setSelectDrawerAdmin] = useState(0);
    const [selectCabinetAdmin, setSelectCabinetAdmin] = useState(0);
    const [selectedCellAdmin, setSelectedCellAdmin] = useState(null);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    // --- INIT DATA ---
    useEffect(() => {
        try {
            if (visible) {
                setNoteChange(data?.note);
                setQuantityChange(data?.qty);

                // Init User Tab
                setDataDrawer([]);
                setDataCell([]);
                setSelectCabinet(data.cabinet_id);
                setSelectDrawer(data.drawer_id);
                setSelectedCell(data.cell_id);

                // Init Admin Tab (Ban đầu set giống user, sau đó admin đổi sau)
                setDataDrawerAdmin([]);
                setDataCellAdmin([]);
                setSelectCabinetAdmin(data.cabinet_id);
                setSelectDrawerAdmin(data.drawer_id);
                getDataCabinet();
                setFlagProcess(false);
                flagRef.current = false;
                isHandledRef.current = false;
            }
        } catch (e) {
            console.error(e);
        }
    }, [visible, data]);

    // --- LOGIC FETCH DATA CHO TAB 1 (USER) ---
    useEffect(() => {
        if (selectCabinet !== 0 && visible && selectCabinet) {
            getDataDrawer(selectCabinet);
        }
    }, [dataCabinet, visible]);

    useEffect(() => {
        if (selectDrawer !== 0 && visible && selectDrawer) {
            getAllCell(selectCabinet, selectDrawer);
        }
    }, [selectDrawer, visible]);

    // --- LOGIC FETCH DATA CHO TAB 2 (ADMIN) ---
    // Khi Admin đổi tủ -> reset drawer, cell, load drawer mới
    useEffect(() => {
        if (visible && selectCabinetAdmin !== 0 && selectCabinetAdmin) {
            // Khi chọn tủ mới, load lại Drawer cho Admin
            getDataDrawerAdmin(selectCabinetAdmin);
        }
    }, [selectCabinetAdmin, visible]);

    // Khi Admin đổi ngăn -> load cell mới
    useEffect(() => {
        if (visible && selectDrawerAdmin !== 0 && selectDrawerAdmin) {
            getAllCellAdmin(selectCabinetAdmin, selectDrawerAdmin);
        }
    }, [selectDrawerAdmin, visible]);

    // ================== API CALLS ==================

    // 1. Get Cabinet (Dùng chung)
    const getDataCabinet = useCallback(() => {
        if (flagRef.current) return;
        flagRef.current = true;
        setFlagProcess(true);
        const InVal = [];
        sendRequest(serviceList.getAllCabinetSp, InVal, getDataCabinetResult, true, timeOutFunct, 15000);
    }, []);

    const getDataCabinetResult = (reqInfoMap, message) => {
        flagRef.current = false;
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            const arrCabinet = message.proc_data.rows[0].o_1;
            const formatted = arrCabinet
                .filter((ele) => ele.block_status == '1')
                .map((ele) => ({
                    label: ele.cabinet_nm,
                    value: ele.id,
                }));
            setDataCabinet(formatted);
        }
    };

    // 2. Get Drawer (USER)
    const getDataDrawer = useCallback(
        (id) => {
            const InVal = [id];
            sendRequest(
                serviceList.getAlldrawerSp,
                InVal,
                (req, msg) => getDataDrawerResult(req, msg, false),
                true,
                timeOutFunct,
                15000
            );
        },
        [selectCabinet]
    );

    // 3. Get Drawer (ADMIN)
    const getDataDrawerAdmin = useCallback(
        (id) => {
            const InVal = [id, data?.device_cd, data?.drawer_id, data?.qty];
            sendRequest(
                serviceList.getListDrawerHaveDeviceCd,
                InVal,
                (req, msg) => getDataDrawerResult(req, msg, true),
                true,
                timeOutFunct,
                15000
            );
        },
        [data]
    );

    // Hàm result chung cho Drawer, phân biệt bằng biến isForAdmin
    const getDataDrawerResult = (reqInfoMap, message, isForAdmin) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const drawerData = [...message.proc_data.rows[0].o_1].filter((ele) => ele.block_status === '1');
            const formatted = drawerData.map((ele) => ({
                label: ele.drawer_nm,
                value: ele.id,
                lc: ele.drawer_lc,
            }));
            if (isForAdmin) {
                setDataDrawerAdmin(formatted);
                setSelectDrawerAdmin(message.proc_data.suggest_drawer);
            } else {
                setDataDrawer(formatted);
                setSelectDrawer(data?.drawer_id);
            }
        }
    };

    // 4. Get Cell (USER)
    const getAllCell = (id_capinet, id_drawer) => {
        const InVal = [idPermission, id_capinet, id_drawer];
        sendRequest(
            serviceList.getAllbox,
            InVal,
            (req, msg) => getDataCellResult(req, msg, false),
            true,
            timeOutFunct,
            15000
        );
    };

    // 5. Get Cell (ADMIN)
    const getAllCellAdmin = (id_capinet, id_drawer) => {
        const InVal = [idPermission, id_capinet, id_drawer];
        sendRequest(
            serviceList.getAllbox,
            InVal,
            (req, msg) => getDataCellResult(req, msg, true),
            true,
            timeOutFunct,
            15000
        );
    };

    // Hàm result chung cho Cell
    const getDataCellResult = (reqInfoMap, message, isForAdmin) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            const cells = [...message.proc_data.rows[0].o_1];
            if (isForAdmin) {
                setDataCellAdmin(cells);
                const cell_select = cells?.find((ele) => ele?.qty > data?.qty && ele?.device_cd === data?.device_cd);
                setSelectedCellAdmin(cell_select);
            } else {
                setDataCell(cells);
                // Với user, trỏ vào ô đã lưu
                setSelectedCell(cells.find((ele) => ele.id === data?.cell_id_fix));
            }
        }
    };

    const handleClick = () => {
        if (isHandledRef.current) return;

        if (!selectedCellAdmin?.id || !selectCabinetAdmin || !selectDrawerAdmin) {
            toast.warning(t('warning_no_cell_admin'));
            setTabValue(1);
            return;
        }

        setFlagProcess(true);
        isHandledRef.current = true;
        const InVal = [data.id, '1', selectedCellAdmin?.id];

        sendRequest(serviceList.changeStatusChangeDevice, InVal, actionResult, true, timeOutFunct, 60000);
    };

    const actionResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
        } else {
            toast.success(message['proc_message']);
            handleClose();
        }
    };

    const timeOutFunct = () => {
        flagRef.current = false;
        setFlagProcess(false);
        toast.error(t('error.time_out'));
    };

    const handleClose = () => {
        setVisible(false);
        setSelectCabinet(0);
        setSelectDrawer(0);
        setSelectedCell(null);
        setSelectCabinetAdmin(0);
        setSelectDrawerAdmin(0);
        setSelectedCellAdmin(null);
        setTabValue(0);
        callBackFunct();
    };

    const handleChangeTab = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <div>
            <BootstrapDialog
                fullScreen={fullScreen}
                open={visible}
                aria-labelledby="customized-dialog-title"
                PaperProps={{ component: 'div' }}
            >
                <Loader loading={loading || flagProcess} />
                <BootstrapDialogTitle style={{ cursor: 'move' }} id="customized-dialog-title">
                    {t('title_popup_change_device')}
                </BootstrapDialogTitle>

                <DialogContent dividers style={{ padding: 26 }}>
                    {/* Phần chung: Note và Quantity */}
                    <Grid container spacing={2}>
                        <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            <TextField
                                label={t('note_change_device')}
                                value={noteChange}
                                size="medium"
                                onChange={(ele) => setNoteChange(ele.currentTarget.value)}
                                disabled
                            />
                            <TextField
                                label={t('amount')}
                                value={quantityChange}
                                size="medium"
                                type="number"
                                onChange={(ele) => setQuantityChange(ele.currentTarget.value)}
                                disabled
                            />
                        </Grid>
                        <TabAdminAssign
                            t={t}
                            dataCabinet={dataCabinet}
                            selectCabinetAdmin={selectCabinetAdmin}
                            setSelectCabinetAdmin={setSelectCabinetAdmin}
                            dataDrawerAdmin={dataDrawerAdmin}
                            selectDrawerAdmin={selectDrawerAdmin}
                            setSelectDrawerAdmin={setSelectDrawerAdmin}
                            dataCellAdmin={dataCellAdmin}
                            selectedCellAdmin={selectedCellAdmin}
                            setSelectedCellAdmin={setSelectedCellAdmin}
                            deviceData={data}
                            requestData={data}
                        />
                    </Grid>
                </DialogContent>

                <DialogActions style={{ padding: '12px 16px' }}>
                    <ButtonAction title={t('close')} onClick={handleClose} color="error" type="cancel" />
                    <ButtonAction onClick={handleClick} type={'confirm'} icon="send" title={t('confirm')} />
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
